import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosAtheneum } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  createUser,
  deleteUser,
  getOneUsers,
  getUserDetails,
} from '../../utils/apiRoutes';

export const getAllUsersAsync = createAsyncThunk(
  `${moduleName}/getAllUsersAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosAtheneum({
      method: 'GET',
      url: getUserDetails(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

export const postUsersAsync = createAsyncThunk(
  `${moduleName}/postUsersAsync`,
  async (payload) => {
    const response = await axiosAtheneum({
      method: 'POST',
      url: createUser(),
      data: payload,
    });
    const data = response.data;
    return data;
    // return response.data;
  }
);

export const getOneUsersAsync = createAsyncThunk(
  `${moduleName}/getOneUsersAsync`,
  async (payload) => {
    const { _id } = payload;
    const response = await axiosAtheneum({
      method: 'GET',
      url: getOneUsers(_id),
    });
    const data = response.data;
    return data;
  }
);

export const deleteOneUserAsync = createAsyncThunk(
  `${moduleName}/deleteOneUserAsync`,
  async (_id) => {
    console.log(_id);
    const response = await axiosAtheneum({
      method: 'DELETE',
      url: deleteUser(_id),
    });
    const data = response.data;
    return data;
  }
);

const userSlice = createSlice({
  name: `${moduleName}/User`,
  initialState: {
    loading: false,
    users: null,
    oneuser: [],
    postuser: null,
  },
  reducers: {},
  extraReducers: {
    [getAllUsersAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllUsersAsync.fulfilled]: (state, action) => {
      console.log('test', action);
      state.loading = false;
      state.users = action.payload;
    },
    [getAllUsersAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [getOneUsersAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getOneUsersAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.oneuser = action.payload;
    },
    [getOneUsersAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [postUsersAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [postUsersAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.postuser = action.payload;
    },
    [postUsersAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    //delete one user
    [deleteOneUserAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteOneUserAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.oneuser = action.payload;
    },
    [deleteOneUserAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default userSlice.reducer;
